var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 24,
    viewBox: "0 0 33 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 0.5H2.5C1.39286 0.5 0.507143 1.39286 0.5 2.5V21.3571C0.514286 22.4643 1.39286 23.3571 2.5 23.3571H30.5C31.6143 23.3571 32.5 22.45 32.5 21.3357V2.52143C32.5 1.40714 31.6143 0.5 30.5 0.5ZM3.72143 2.78571H29.2714C29.7643 2.78571 30.1357 3.15 30.2071 3.64286V5.07143H2.78571V3.62143C2.85714 3.13571 3.23571 2.78571 3.72143 2.78571ZM3.72143 21.0714H29.2786C29.7643 21.0714 30.1429 20.7071 30.2143 20.2143V11.9286H2.78571V20.2357C2.85714 20.7214 3.22857 21.0714 3.72143 21.0714Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07129 15.3572H18.7856V16.5H5.07129V15.3572ZM5.07129 17.6429H11.9284V18.7857H5.07129V17.6429ZM27.9284 15.3572H23.357V18.7857H27.9284V15.3572Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.2c6fb569c0bc89057e8584eaf29dba14.svg";
export { ForwardRef as ReactComponent };